import { Drawer, Form, Select, Button } from "antd";
import { useState } from "react";

const UsersFilters = ({
  showFilter = false,
  onCloseHandler = () => {},
  formRequisites = {},
  handleFilterSubmit = {}
}) => {
  const [form] = Form.useForm();
  const [filter, setFilter] = useState({});

  return (
    <Drawer
      title="User Filters"
      placement="left"
      open={showFilter}
      width="min(340px, 100vw)"
      onClose={() => {
        onCloseHandler(false);
      }}
    >
      <Form
        form={form}
        name="users_filters_form"
        onFinish={() => {
          handleFilterSubmit(filter);
        }}
        layout="vertical"
      >
        <Form.Item
          name="batch"
          label="Batch"
          rules={[
            {
              required: true,
              message: "Please select a batch!"
            }
          ]}
        >
          <Select
            options={formRequisites.batches || []}
            showSearch
            allowClear
            value={(filter || {})["batch"]}
            onChange={(e) => {
              setFilter({
                ...filter,
                batch: e
              });
            }}
          />
        </Form.Item>
        <Form.Item name="codeforcesLinked" label="Codeforces Linked">
          <Select
            options={[
              { label: "True", value: true },
              { label: "False", value: false }
            ]}
            allowClear
            value={(filter || {})["codeforcesLinked"]}
            onChange={(e) => {
              setFilter({
                ...filter,
                codeforcesLinked: e
              });
            }}
          />
        </Form.Item>

        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            Apply
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};
export default UsersFilters;
